import getConfig from 'next/config';

import { getUrlParamFromCookie } from './cookies';
import getUrlSearchParams from './getUrlSearchParams';
import { getAnonymousId } from './getAnonymousId';

import { WebRegUrls, envEnum } from '../context/PageData';

const { publicRuntimeConfig } = getConfig();
const { nodeEnv, webregUrl } = publicRuntimeConfig;

interface WebRegBits {
  baseUrl: string;
  phoneNumber: string;
  forwardedUrlParams?: string[] | null;
  bypassPhoneNumberEntry: boolean;
  forwardedCtaParams?: string | null;
  forwardedButtonParams?: string | null;
}

export function getRedirectByEnv(webRegUrls: WebRegUrls = {}) {
  const env = nodeEnv as keyof typeof envEnum;
  // Use webreg url from contentful or default to env variable
  return webRegUrls[envEnum[env]] || webregUrl;
}

export function appendParams({
  baseUrl,
  phoneNumber,
  forwardedUrlParams,
  bypassPhoneNumberEntry,
  forwardedCtaParams,
  forwardedButtonParams
}: WebRegBits) {
  const anonymousId = getAnonymousId();
  // Default is organic; If no cookies, assumed to be incognito
  const utmSource = getUrlParamFromCookie('utm_source');
  const utmMedium = getUrlParamFromCookie('utm_medium');
  const utmCampaign = getUrlParamFromCookie('utm_campaign');
  const utmTerm = getUrlParamFromCookie('utm_term');
  const utmContent = getUrlParamFromCookie('utm_content');
  const irclickid = getUrlParamFromCookie('irclickid');
  const branchMatchId = getUrlParamFromCookie('_branch_match_id');
  const buttonParams = forwardedButtonParams ? `&${forwardedButtonParams}` : '';
  const ctaParams = forwardedCtaParams ? `&${forwardedCtaParams}` : '';
  const addtlParams = getUrlSearchParams(
    forwardedUrlParams as string[],
    buttonParams,
    ctaParams
  );

  const url = new URL(baseUrl || '');

  if (bypassPhoneNumberEntry === false) {
    url.searchParams.append('phoneNumber', phoneNumber);
  }

  if (anonymousId) {
    url.searchParams.append('anonymous_id', encodeURIComponent(anonymousId));
  }

  if (!utmSource) {
    url.searchParams.append('utm_source', 'incognito');
  }

  return `${url}${utmSource}${utmMedium}${utmCampaign}${utmTerm}${utmContent}${irclickid}${branchMatchId}${addtlParams}${ctaParams}${buttonParams}`;
}
